module.exports = __webpack_public_path__ + "media/images/top-design-03-bd1271b7972711d516613d5b50a9b303.jpg";